import { Button, Counter } from "@maxhub/max-ui"
import { useState } from "react"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

const INDICATOR_MAP = {
    none: undefined,
    Counter: <Counter value={3} />,
}

const BUTTON_VARIANTS = ['primary', 'secondary', 'ghost', 'primary-contrast', 'secondary-contrast', 'overlay', 'destructive']

export const ButtonExample = {
    title: 'Button',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'variant',
            label: 'variant',
            type: 'enum',
            tsType: BUTTON_VARIANTS.map((variant) => `"${variant}"`),
            default: 'primary',
            options: BUTTON_VARIANTS,
        },
        {
            name: 'size',
            label: 'size',
            type: 'enum',
            tsType: ['"xsmall"', '"small"', '"medium"', '"large"'],
            default: 'medium',
            options: ['xsmall', 'small', 'medium', 'large'],
        },
        {
            name: 'iconAfter',
            label: 'iconAfter',
            type: 'boolean',
            tsType: 'ReactNode',
            default: false,
        },
        {
            name: 'iconBefore',
            label: 'iconBefore',
            type: 'boolean',
            tsType: 'ReactNode',
            default: false,
        },
        {
            name: 'indicator',
            label: 'indicator',
            type: 'select',
            tsType: 'ReactNode',
            default: 'none',
            options: [
                { value: 'none', label: 'none' },
                { value: 'Counter', label: 'Counter' },
            ],
        },
        {
            name: 'children',
            label: 'children',
            type: 'text',
            tsType: 'string',
            default: 'Button',
        },
        {
            name: 'disabled',
            label: 'disabled',
            type: 'boolean',
            tsType: 'boolean',
            default: false,
        },
        {
            name: 'stretched',
            label: 'stretched',
            type: 'boolean',
            tsType: 'boolean',
            default: false,
        },
        {
            name: 'loading',
            label: 'loading',
            type: 'boolean',
            tsType: 'boolean',
            default: false,
        },
        {
            name: 'innerClassNames',
            label: 'innerClassNames',
            type: 'static',
            tsType: 'InnerClassNamesProp<ButtonInnerElementKey>',
            value: '-',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
    ],

    Preview({ props }){
        const buttonProps = {
            variant: props.variant,
            size: props.size,
            disabled: props.disabled,
            stretched: props.stretched,
            loading: props.loading,
            iconAfter: props.iconAfter ? <PlaceholderIcon/> : undefined,
            iconBefore: props.iconBefore ? <PlaceholderIcon/> : undefined,
            indicator: INDICATOR_MAP[props.indicator] || undefined,
            onClick: () => {},
        }

        return (
            <Button {...buttonProps}>
                {props.children}
            </Button>
        )
    },

    getCode(props){
        const lines = []
        if (props.variant !== 'primary') lines.push(`  variant="${props.variant}"`)
        if (props.size !== 'medium') lines.push(`  size="${props.size}"`)
        if (props.disabled) lines.push(`  disabled`)
        if (props.loading) lines.push(`  loading`)
        if (props.stretched) lines.push(`  stretched`)
        if (props.iconBefore) lines.push(`  iconBefore={<PlaceholderIcon />}`)
        if (props.iconAfter) lines.push(`  iconAfter={<PlaceholderIcon />}`)
        if (props.indicator !== 'none') lines.push(`  indicator={<Counter value={3} />}`)

        const propsStr = lines.length > 0 ? '\n' + lines.join('\n') + '\n' : ''
        return `<Button${propsStr}>
  ${props.children}
</Button>`
    }

}